import { Column, DateTimePicker, Label, Row, Select } from '../../../components'
import { FallbackComponent } from '../../../shared/components/FallbackComponent'
import { ErrorBoundary } from 'react-error-boundary'
import TextInputWithLabelInline from '../../../shared/components/input/TextInputWithLabelInline';
import TextFieldWithLabelInline from '../../../shared/components/input/TextFieldWithLabelInline';
import * as label from '../../../shared/util/label'
import './ScreenPrivilege.scss';
import RoleDetailsModel from '../../model/RoleDetailsModel'
import ScreenPrivilegeGrid from './ScreenPrivielgeGrid';
import ScreenElementPrivlegeModel from '../../model/ScreenElementPrivlegeModel';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { SelectOption } from '../../../shared/components/input/SelectOption';
import ScreenPrivilegeService from './ScreenPrivilegeService';
import AppContext from '../../../shared/components/AppContext';
import * as constant from '../../../shared/util/constant'
import { useConfirmationModalContext } from "../../../shared/components/ModalConfirmationContext";
import AppRolePrivielge from '../../model/AppRolePrivielge';
import { toast } from 'react-toastify';
import Logger from '../../../shared/services/Logger';
import { Container, Button, FloatingLabel, Form } from 'react-bootstrap';
import EntityHistoryGrid from '../../../shared/components/entity-history/EntityHistoryGrid';
import { CustomerHistoryLabel as cstHistoryLabel } from '../../../shared/util/label';
import { CommonUtility } from '../../../Services/CommonUtility';
import ExportToCsv from '../../../shared/components/ExportToCSV/ExportToCsv';
import { get } from 'lodash';
import { AbilityContext } from '../../../shared/abilities/AbilityContext';
import DocuMateScanService from '../../../DocuMate/DocuMateScan/DocuMateScanService';
import moment from 'moment';

const reasonForChangeMaxLength = 80;

interface Props {
    roleId: string
    onCancel: () => void;
    onSave: (value: String) => void;
}


const ScreenPrivilege = (props: Props) => {
    const ability = useContext(AbilityContext);
    const roleId = props.roleId
    const canCreate = ability.can('create', constant.AdminSubject, constant.AdminScreenPrivileges.Role_Privilege_Setup);
    const canUpdate = ability.can('update', constant.AdminSubject, constant.AdminScreenPrivileges.Role_Privilege_Setup);

    const [screenPrivilegeGrids, setScreenPrivilegeGrids] = useState<ScreenElementPrivlegeModel[][]>([]);

    const screenPrivilegeService = new ScreenPrivilegeService();

    const [screenOptions, setScreenOptions] = useState<SelectOption[]>([]);

    const [selectedScreenOptions, setSelectedScreenOptions] = useState<{ [key: number]: string }>({});

    const initialScreenPrivilegeGridData: ScreenElementPrivlegeModel[] = [];

    const initialRoleDetails: RoleDetailsModel = {
        id: '',
        roleName: '',
        roleDescription: '',
        defaultDocumateGroup: '',
    }

    const initialScreenPrivilege: AppRolePrivielge = {
        roleDetails: initialRoleDetails,
        featurePrivielges: []
    };

    const intialValidationState = {
        roleName: { isValid: true, message: '' },
        roleDescription: { isValid: true, message: '' },
        reasonForChange: { isValid: true, message: '' },
    };

    const [roleDetails, setRoleDetails] = useState<RoleDetailsModel>(initialRoleDetails)

    const [roleScreenDetails, setRoleScreenDetails] = useState<AppRolePrivielge>(initialScreenPrivilege);

    const modalContext = useConfirmationModalContext();

    const roleDetailsContext = useContext(AppContext);

    const [validations, setValidations] = useState(intialValidationState);
    const [historyGridData, setHistoryGridData] = useState([]);
    const roleHistoryGridRef = useRef<any>(null);
    const [roleHistoryTabAcsess, setRoleHistoryTabAcsess] = useState<boolean>(false);
     const [documateGroups, setDocumateGroups] = useState<any[]>([]);    
    const [historyFromDate, setHistoryFromDate] = useState<Date | null>(null);
    const [historyToDate, setHistoryToDate] = useState<Date | null>(null);
    const [appliedHistoryDateRange, setAppliedHistoryDateRange] = useState<{ fromDate: Date | null, toDate: Date | null }>({ fromDate: null, toDate: null });
    const [historyDateRangeError, setHistoryDateRangeError] = useState('');
    const reasonForChangeRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        initializeFeatures();    
        FetchDocumateGroups();  
        setHistoryGridData([]);     
    }, []);

    useEffect(() => {
        setScreenPrivilegeGrids([]);
        setRoleDetails(initialRoleDetails)
        setValidations(intialValidationState)
        setSelectedScreenOptions([]);
        setHistoryGridData([]); 
        if (reasonForChangeRef.current) {
            reasonForChangeRef.current.value = '';
        }
        resetHistoryDateFilter();

        if (roleId) {
            getRoleDetails();
        }
    }, [roleId]);

    useEffect(() => {
        if (roleHistoryTabAcsess && roleId) {
            getRolePrivilegeHistory();
        }
    }, [roleHistoryTabAcsess, roleId]);

    useEffect(() => {
        setRoleScreenDetails({
            ...roleScreenDetails,
            roleDetails: roleDetails
        })
    }, [roleDetails]);

    useEffect(() => {
        setRoleScreenDetails({
            ...roleScreenDetails,
            featurePrivielges: screenPrivilegeGrids.map(grid => ({
                elementPrivilege: grid,
                featureId: grid[0]?.featureId
            }))
        })

    }, [screenPrivilegeGrids]);

    const onRoleScreenDetailsUpdate = async (roleScreenDetails : AppRolePrivielge) => {
        setRoleDetails(roleScreenDetails.roleDetails)
        const existingScreenOptionsSelected = roleScreenDetails.featurePrivielges.map(fp => fp.featureId);
        setSelectedScreenOptions(existingScreenOptionsSelected.reduce((acc, curr, index) => {
            acc[index] = curr;
            return acc;
        }, {}));
        setScreenPrivilegeGrids(roleScreenDetails.featurePrivielges.map(fp => fp.elementPrivilege))
    }

    const initializeFeatures = async () => {
        try {
            let response = await screenPrivilegeService.getFeatures();
            setScreenOptions(response)
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }

         if (ability.can('view', constant.ADMIN_HISTORY_ACCESS_GROUP, constant.RolePrivilegeSetup.ROLE_SETUP_HISTORY) && ability.can('read', constant.ADMIN_HISTORY_ACCESS_GROUP, constant.RolePrivilegeSetup.ROLE_SETUP_HISTORY))
        {
            setRoleHistoryTabAcsess(true);
        } 
    }

    const getRolePrivilegeHistory = async () => {
        if(roleHistoryTabAcsess)
        {
            try {
                let response = await screenPrivilegeService.getRolePrivilegeHistory(roleId);
                setHistoryGridData(response)
            }
            catch (error) {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                Logger.logError(error.toString());
            }
       }
    }

    // History rows are filtered only against the range applied via GET RESULTS, not the in-progress selection.
    const filteredHistoryGridData = useMemo(() => {
        const { fromDate, toDate } = appliedHistoryDateRange;
        if (!fromDate && !toDate) {
            return historyGridData;
        }

        return historyGridData.filter((record: any) => {
            const changedDate = moment(record.changedDate, CommonUtility.DateTimeFormatWithSecond);
            if (!changedDate.isValid()) {
                return false;
            }
            if (fromDate && changedDate.isBefore(moment(fromDate).startOf('day'))) {
                return false;
            }
            if (toDate && changedDate.isAfter(moment(toDate).endOf('day'))) {
                return false;
            }
            return true;
        });
    }, [historyGridData, appliedHistoryDateRange]);

    const validateHistoryDateRange = (fromDate: Date | null, toDate: Date | null) => {
        const isInvalid = !!fromDate && !!toDate && moment(fromDate).startOf('day').isAfter(moment(toDate).startOf('day'));
        setHistoryDateRangeError(isInvalid ? constant.INVALID_DATE_RANGE : '');
        return !isInvalid;
    }

    const handleHistoryFromDateChange = (date: Date) => {
        setHistoryFromDate(date);
        validateHistoryDateRange(date, historyToDate);
    }

    const handleHistoryToDateChange = (date: Date) => {
        setHistoryToDate(date);
        validateHistoryDateRange(historyFromDate, date);
    }

    const handleGetHistoryResults = () => {
        if (!validateHistoryDateRange(historyFromDate, historyToDate)) {
            return;
        }
        setAppliedHistoryDateRange({ fromDate: historyFromDate, toDate: historyToDate });
    }

    const resetHistoryDateFilter = () => {
        setHistoryFromDate(null);
        setHistoryToDate(null);
        setHistoryDateRangeError('');
        setAppliedHistoryDateRange({ fromDate: null, toDate: null });
    }

    const getRoleHistoryExportData = () =>
        (roleHistoryGridRef.current?.getFilteredRowsForExport() ?? [])
            .map((record: any, index: number) => ({
                ...record,
                historyRowNumber: index + 1
            }));

    const noHistoryRecordFound = <div className='role-nohistorylabel'>{constant.NO_HISTORY_RECORD_FOUND}</div>;

    const getRoleDetails = async () => {
        try {
            let response = await screenPrivilegeService.getRoleDetails(roleId);
            setRoleScreenDetails(response)
            onRoleScreenDetailsUpdate(response)
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }

    const FetchDocumateGroups = async () => {
            try {
                const documateServiceObj = new DocuMateScanService();
                const groupData = await documateServiceObj.getListOfDestinationFoldersData();
                const actualGroups = Array.isArray(groupData) ? groupData : [];
                const groupsData = actualGroups.map(group => ({
                    value: group.GroupId,
                    label: group.GroupName
                }));
                setDocumateGroups(groupsData);
            }
            catch (error) {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
    
                Logger.logError(error.toString());
                setDocumateGroups([]);
            }
        }

    const handleAddScreenPrivilege = () => {
        setScreenPrivilegeGrids([...screenPrivilegeGrids, initialScreenPrivilegeGridData])
        roleDetailsContext.formSavedStatus = false;
    };

    const handleScreenOptionChange = (selectedValue: string, gridIndex: number) => {
        setSelectedScreenOptions((prevSelected) => ({
            ...prevSelected,
            [gridIndex]: selectedValue,
        }));
        //  roleDetailsContext.formSavedStatus = false;
    };

    const getFilteredScreenoptions = (gridIndex: number) => {
        return screenOptions.filter(
            (option) =>
                !Object.values(selectedScreenOptions).includes(option.value) ||
                selectedScreenOptions[gridIndex] === option.value
        )
    }

    const handleScreenPrivilegeChange = (index: number, updatedData: ScreenElementPrivlegeModel[]) => {
        roleDetailsContext.formSavedStatus = false;
        setScreenPrivilegeGrids((prevGrids) => {
            const newGrids = [...prevGrids];
            newGrids[index] = updatedData;
            return newGrids;
        })
    }

    const onCancel = async () => {
        const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
        if (result) {
            setRoleDetails(initialRoleDetails)
            setScreenPrivilegeGrids([])
            if (reasonForChangeRef.current) {
                reasonForChangeRef.current.value = '';
            }
            roleDetailsContext.formSavedStatus = true;
            props.onCancel();
            await getRolePrivilegeHistory();
        }
    }

    const validateLength = (value: string, min: number, max: number) => {
        if (value.length === 0)
            return 'required';
        else if (value.length < min)
            return 'tooShort';
        else if (value.length > max)
            return 'tooLong';
        else
            return null
    }

    const getValidationMessage = (fieldName: string, errorType: string | null) => {
        if (!errorType)
            return '';
        else if (errorType === 'required')
            return constant.FIELD_BLANK
        else if (errorType === 'tooShort' || errorType === 'tooLong') {
            if (fieldName === 'roleName')
                return constant.NAME_LEN_ERROR
            else if (fieldName === 'roleDescription')
                return constant.DESCRIPTION_LEN_ERROR
            else return '';
        }
        else return '';
    }

    const validateForSave = () => {
        const roleNameError = validateLength(roleDetails.roleName, 3, 150);
        const roleDescriptionError = validateLength(roleDetails.roleDescription, 3, 250);
        const reasonError = validateLength(reasonForChangeRef.current?.value.trim() ?? '', 1, reasonForChangeMaxLength);
        setValidations({
            roleName: {
                isValid: !roleNameError,
                message: getValidationMessage('roleName', roleNameError),
            },
            roleDescription: {
                isValid: !roleDescriptionError,
                message: getValidationMessage('roleDescription', roleDescriptionError),
            },
            reasonForChange: {
                isValid: !reasonError,
                message: reasonError === 'required' ? constant.FIELD_BLANK : '',
            },
        });

        return !roleNameError && !roleDescriptionError && !reasonError
    };

    const onSave = async () => {
        if (validateForSave()) {
            const payload: AppRolePrivielge = {
                ...roleScreenDetails,
                reasonForChange: reasonForChangeRef.current?.value.trim() ?? ''
            };
            if (!roleScreenDetails.roleDetails.id) {
                try {
                    const saveRoleDetailsResposne = await screenPrivilegeService.saveRoleDetails(payload)
                    if (saveRoleDetailsResposne) {
                        if (reasonForChangeRef.current) {
                            reasonForChangeRef.current.value = '';
                        }
                        toast.success(constant.RolePrivilege.ROLE_SAVED_SUCCESSFULLY, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: constant.AUTO_CLOSE
                        });
                        setRoleScreenDetails(saveRoleDetailsResposne)
                        roleDetailsContext.formSavedStatus = true;
                        props.onSave(saveRoleDetailsResposne.roleDetails.id)
                        await getRolePrivilegeHistory();
                    }
                    else {
                        toast.error(constant.RolePrivilege.ROLE_ERROR_WHILE_SAVING, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: constant.AUTO_CLOSE
                        });
                        roleDetailsContext.formSavedStatus = false;
                    }
                } catch (error) {
                    toast.error(constant.RolePrivilege.ROLE_ERROR_WHILE_SAVING, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: constant.AUTO_CLOSE
                    });
                    Logger.logError(error.toString());// Catch any additional errors
                    roleDetailsContext.formSavedStatus = false;
                }
            }
            else {
                try {
                    const updateRoleDetailsResposne = await screenPrivilegeService.updateRoleDetails(payload)
                    if (updateRoleDetailsResposne) {
                        if (reasonForChangeRef.current) {
                            reasonForChangeRef.current.value = '';
                        }
                        toast.success(constant.RolePrivilege.ROLE_SAVED_SUCCESSFULLY, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: constant.AUTO_CLOSE
                        });
                        setRoleScreenDetails(updateRoleDetailsResposne)
                        onRoleScreenDetailsUpdate(updateRoleDetailsResposne)
                        roleDetailsContext.formSavedStatus = true;
                         props.onSave(updateRoleDetailsResposne.roleDetails.id)
                         await getRolePrivilegeHistory();

                    }
                    else {
                        toast.error(constant.RolePrivilege.ROLE_ERROR_WHILE_SAVING, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: constant.AUTO_CLOSE
                        });
                        roleDetailsContext.formSavedStatus = false;
                    }
                } catch (error) {
                    toast.error(constant.RolePrivilege.ROLE_ERROR_WHILE_SAVING, {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: constant.AUTO_CLOSE
                    });
                    Logger.logError(error.toString()); // Catch any additional errors
                    roleDetailsContext.formSavedStatus = false;
                }
            }
        }
        else {
            toast.warn(constant.RolePrivilege.ROLE_VALIDATION_ERROR_MESSAGE, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const onFieldChange = (name: string, value: string) => {
        setRoleDetails({
            ...roleDetails,
            [name]: value
        })
        roleDetailsContext.formSavedStatus = false;
    }

    return (
        <Container fluid>
<Row className="screenPrivilegeDetails">
            <Column lg={12} md={12}>
                <ErrorBoundary FallbackComponent={FallbackComponent}>
                    <Column lg={12} md={12} className=''>
                        <Row>
                            <Column>
                                {roleId ?
                                    <Label text={`EDIT ${roleDetails.roleName.toLocaleUpperCase()}`} className='role-name-label'></Label>
                                    : null}
                            </Column>
                        </Row>
                        <Row className='cstPanel'>
                            <Column lg={4}>
                                    <FloatingLabel
                                        controlId="roleName"
                                        label={
                                            <>
                                                {label.RolePrivilegeSetupLabels.ROLE}
                                                <span className="text-danger">*</span>
                                            </>
                                        }>                                        
                                        <Form.Control
                                            type="text"
                                            name="roleName"
                                            placeholder={label.RolePrivilegeSetupLabels.ROLE_NAME}
                                            value={roleDetails.roleName || ""}
                                            onChange={(event) => onFieldChange('roleName', event.currentTarget.value)}
                                            disabled={false} // Set to true if the field should be non-editable
                                            maxLength={150}
                                            required={true}
                                            isInvalid={!validations.roleName.isValid}
                                            tabIndex={1}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {validations.roleName.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                
                            </Column>
                            <Column lg={6}>
                                    <FloatingLabel
                                        controlId="roleDescription"
                                        label={
                                            <>
                                                {label.DESCRIPTION}
                                                <span className="text-danger">*</span>
                                            </>
                                        }>
                                        <Form.Control
                                            type="text"
                                            name="roleDescription"
                                            placeholder={label.DESCRIPTION}
                                            value={roleDetails.roleDescription || ""}
                                            onChange={(event) => onFieldChange('roleDescription', event.currentTarget.value)}
                                            disabled={false} // Set to true if the field should be non-editable
                                            maxLength={250}
                                            required={true}
                                            isInvalid={!validations.roleDescription.isValid}
                                            tabIndex={2}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {validations.roleDescription.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                            </Column>
                              <Column>
                                <Select
                                                                            id="documateGroupDD"
                                                                            key={roleDetails.defaultDocumateGroup}
                                                                            controlId="documateGroupDD"
                                                                            className='mb-3'
                                                                            placeholder={label.DEFAULT_DOCUMATE_GROUP_DDL}
                                                                            label={label.DEFAULT_DOCUMATE_GROUP_DDL}
                                                                            options={documateGroups}                                                                            
                                                                            defaultSelected={documateGroups?.filter(option =>
                                                                                    option.value === roleDetails.defaultDocumateGroup
                                                                                )}
                                                                            onChange={(values) => onFieldChange('defaultDocumateGroup', values[0] as string)}
                                                                            disabled={false}                                                                            
                                                                            tabIndex={3}
                                                                        />
                            </Column>
                            </Row>
                            <Row style={{ marginBottom: '1.3%' }}>
                            <Column>
                            </Column>
                        </Row>
                        <Row>
                            <Column>
                                {screenPrivilegeGrids.map((gridData, index) => (
                                    <ScreenPrivilegeGrid
                                        key={index}
                                        gridIndex={index}
                                        screenPrivilegeData={gridData}
                                        screenOptions={getFilteredScreenoptions(index)}
                                        onScreenDropDownChange={(selectedValue) => handleScreenOptionChange(selectedValue, index)}
                                        onGridDataChange={(updatedData) => handleScreenPrivilegeChange(index, updatedData)}
                                        zIndexHeader={10000 - index * 100} children={''}>
                                    </ScreenPrivilegeGrid>
                                ))}
                            </Column>
                        </Row>
                        
                        <Row className='screen-privelege-footer mt-3'>
                            <Column lg={12} className=''>
                            <div className='d-flex flex-wrap gap-2 justify-content-between align-items-start'>
                            <Button color='primary' variant='outline-success' onClick={handleAddScreenPrivilege} disabled={!canCreate}>{label.RolePrivilegeSetupLabels.ADD_SCREEN_PRIVILEGE}</Button>

                            <FloatingLabel
                                controlId='reasonForChange'
                                label='Reason for change *'
                                className='role-reason-for-change ms-auto'
                            >
                                <Form.Control
                                    ref={reasonForChangeRef}
                                    type='text'
                                    name='reasonForChange'
                                    placeholder='Ticket # or note'
                                    defaultValue=''
                                    maxLength={reasonForChangeMaxLength}
                                    disabled={!canUpdate}
                                    required
                                    isInvalid={!validations.reasonForChange.isValid}
                                />
                                <Form.Control.Feedback type='invalid'>
                                    {validations.reasonForChange.message}
                                </Form.Control.Feedback>
                            </FloatingLabel>
                            <Button color='primary' variant='outline-primary' onClick={onCancel}>{label.CANCEL.toUpperCase()}</Button>
                            <Button color='primary'  onClick={onSave} className='ms-2' disabled={!canUpdate}>{label.SAVE.toUpperCase()} ROLE</Button>

                                </div>
                            </Column>
                        </Row>
                      {roleHistoryTabAcsess && (   <Row>
                            {historyGridData!== null && historyGridData.length > 0 ? (
                <div>
                    {filteredHistoryGridData.length > 0 ? (
                    <EntityHistoryGrid
                        gridRef={roleHistoryGridRef}
                        data={filteredHistoryGridData}
                        columns={[
                            {
                                Header: '#',
                                id: 'historyRowNumber',
                                Cell: ({ row, rows }) => rows.findIndex(item => item.id === row.id) + 1,
                                width: 80,
                                disableSortBy: true,
                                disableFilters: true,
                                hideColumnFilter: true
                            },
                            {
                                Header: cstHistoryLabel.USER,
                                accessor: 'changedBy',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 250
                            },
                            {
                                Header: cstHistoryLabel.TIMESTAMP,
                                accessor: 'changedDate',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 250
                            },
                            {
                                Header: cstHistoryLabel.FIELD,
                                accessor: 'fieldName',
                                Cell: row => {
                                    let displayValue = row.value;
                                    if (typeof displayValue === 'string' && displayValue.startsWith('_')) {
                                        displayValue = CommonUtility.capitalizeFirstCharOfEachWord(displayValue.substring(1));
                                    }
                                    return <div><span title={displayValue}>{displayValue}</span></div>;
                                },
                                width: 275
                            },
                            {
                                Header: cstHistoryLabel.OLD_VALUE,
                                accessor: 'oldValue',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 300
                            },
                            {
                                Header: cstHistoryLabel.NEW_VALUE,
                                accessor: 'newValue',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 300
                            },
                            {
                                Header: cstHistoryLabel.ACTION,
                                accessor: 'action',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 190
                            },
                            {
                                Header: cstHistoryLabel.ENTITY,
                                accessor: 'entity',
                                Cell: row => <div><span title={row.value}>{row.value}</span></div>,
                                width: 200
                            },
                            {
                                Header: cstHistoryLabel.REASON,
                                accessor: 'reasonForChange',
                                Cell: row => <div className='role-history-reason' title={row.value}>{row.value}</div>,
                                width: 250
                            }
                        ]}
                        hiddenColumns={['selection']}
                        groupByColumns={[]}
                        columnsGroupOn={[]}
                        showFilters={true}
                        sortDefault={[]}
                        defaultPageSize={10}
                        paginationDisabled={false}
                        entityHistoryMainDivClassName="role-history-grd-div"
                        entityHistoryGrdTableContainerClass="role-history-table-container"
                        modalClassName=""
                    />
                    ) : (
                        noHistoryRecordFound
                    )}
                    {historyDateRangeError && (
                        <div className='invalid-feedback d-block role-history-daterange-error'>{historyDateRangeError}</div>
                    )}
                    <div className='role-history-filter'>
                        <DateTimePicker
                            name='historyFromDate'
                            selected={historyFromDate}
                            onChange={handleHistoryFromDateChange}
                            maxDate={new Date()}
                            className='role-history-datepicker'
                            placeholderText={label.RolePrivilegeSetupLabels.HISTORY_FROM_DATE}
                            isInvalid={historyDateRangeError !== ''}
                        />
                        <DateTimePicker
                            name='historyToDate'
                            selected={historyToDate}
                            onChange={handleHistoryToDateChange}
                            maxDate={new Date()}
                            className='role-history-datepicker'
                            placeholderText={label.RolePrivilegeSetupLabels.HISTORY_TO_DATE}
                            isInvalid={historyDateRangeError !== ''}
                        />
                        <Button color='primary' onClick={handleGetHistoryResults} disabled={!historyFromDate && !historyToDate}>{label.RolePrivilegeSetupLabels.GET_RESULTS}</Button>
                        <Button color='primary' variant='outline-primary' onClick={resetHistoryDateFilter}>{label.RolePrivilegeSetupLabels.RESET}</Button>
                        <ExportToCsv
                            data={filteredHistoryGridData}
                            onExport={getRoleHistoryExportData}
                            headers={[
                                '#',
                                cstHistoryLabel.USER,
                                cstHistoryLabel.TIMESTAMP,
                                cstHistoryLabel.FIELD,
                                cstHistoryLabel.OLD_VALUE,
                                cstHistoryLabel.NEW_VALUE,
                                cstHistoryLabel.ACTION,
                                cstHistoryLabel.ENTITY,
                                cstHistoryLabel.REASON
                            ]}
                            fileName="Role Privilege History.csv"
                            getRow={row => [
                                row.historyRowNumber,
                                row.changedBy,
                                new Date(row.changedDate).toLocaleString('en-US'),  
                                (typeof row.fieldName === 'string' && row.fieldName.startsWith('_')) ? CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName.substring(1)) : CommonUtility.capitalizeFirstCharOfEachWord(row.fieldName),
                                row.oldValue,
                                row.newValue,
                                row.action,
                                row.entity,
                                row.reasonForChange ?? ''
                            ]}
                        />
                    </div>
                </div>
                    ) : (
                        noHistoryRecordFound
                    )}
                        </Row>
                      )}
                    </Column>
                </ErrorBoundary>
            </Column>
        </Row>
        </Container>
        

    );
}

export default ScreenPrivilege;